import { render } from "./TrainDonorComponent.vue?vue&type=template&id=4470a438&scoped=true"
import script from "./TrainDonorComponent.vue?vue&type=script&lang=js"
export * from "./TrainDonorComponent.vue?vue&type=script&lang=js"

import "./TrainDonorComponent.vue?vue&type=style&index=0&id=4470a438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4470a438"]])

export default __exports__